import { EmptyStatePrimaryAction } from '@synoptic/ui-kit/empty-state/empty-state-primary-action.tsx';
import { EmptyState } from '@synoptic/ui-kit/empty-state/empty-state.tsx';
import { EmojiSadIcon } from '@synoptic/ui-kit/icons/react/emoji-sad.tsx';
import { LayoutCard } from '@/components/layout/card.tsx';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { streamBannerNotFound } from './stream-banner-empty-state.css.ts';

export const StreamBannerEmptyState = () => {
  return (
    <LayoutCard className={streamBannerNotFound}>
      <EmptyState
        illustration={<EmojiSadIcon />}
        heading="Not found"
        description="The stream you are looking for does not exist."
        action={
          <EmptyStatePrimaryAction asChild>
            <Link to={paths.streams}>View all streams</Link>
          </EmptyStatePrimaryAction>
        }
      ></EmptyState>
    </LayoutCard>
  );
};
